import { useMemo } from 'react'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES, NLS_HOLIDAY_PERIODS_ROLLOUT } from 'constants/search'

export default function useTypeaheadRollout(
  types: Array<string> | undefined,
  rollout: Array<string> | undefined,
): Array<string> | undefined {
  const nlsHolidayPeriodsEnabled = useFeatureFlag(OptimizelyFeatureFlags.searchNlsHolidayPeriods)
  const isHotelSearch = types === HOTEL_SEARCH_TYPEAHEAD_TYPES

  return useMemo(() => {
    if (!isHotelSearch || !nlsHolidayPeriodsEnabled || rollout?.includes(NLS_HOLIDAY_PERIODS_ROLLOUT)) return rollout

    return [...(rollout ?? []), NLS_HOLIDAY_PERIODS_ROLLOUT]
  }, [nlsHolidayPeriodsEnabled, isHotelSearch, rollout])
}
